module.exports = {"540172400":"拉萨市经济技术开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540172.json
// module id = 2684
// module chunks = 0